import lazyScreen from '../utils/lazyScreen';
const FAAssets = lazyScreen(() => import('../pages/fa/FAAssets/index.js'), 'pages/fa/FAAssets/index.js');
const FAAsset = lazyScreen(() => import('../pages/fa/FAAsset/index.js'), 'pages/fa/FAAsset/index.js');
const FAAssetDepreciates = lazyScreen(() => import('../pages/fa/FAAssetDepreciates/index.js'), 'pages/fa/FAAssetDepreciates/index.js');
const FAAssetDisposes = lazyScreen(() => import('../pages/fa/FAAssetDisposes/index.js'), 'pages/fa/FAAssetDisposes/index.js');
const FAAssetDispose = lazyScreen(() => import('../pages/fa/FAAssetDispose/index.js'), 'pages/fa/FAAssetDispose/index.js');
const FAAssetRegisters = lazyScreen(() => import('../pages/fa/FAAssetRegisters/index.js'), 'pages/fa/FAAssetRegisters/index.js');
const FAAssetRegister = lazyScreen(() => import('../pages/fa/FAAssetRegister/index.js'), 'pages/fa/FAAssetRegister/index.js');
const FAAssetAdjIncs = lazyScreen(() => import('../pages/fa/FAAssetAdjIncs/index.js'), 'pages/fa/FAAssetAdjIncs/index.js');
const FAAssetAdjInc = lazyScreen(() => import('../pages/fa/FAAssetAdjInc/index.js'), 'pages/fa/FAAssetAdjInc/index.js');
const FAAssetAdjDecs = lazyScreen(() => import('../pages/fa/FAAssetAdjDecs/index.js'), 'pages/fa/FAAssetAdjDecs/index.js');
const FAAssetAdjDec = lazyScreen(() => import('../pages/fa/FAAssetAdjDec/index.js'), 'pages/fa/FAAssetAdjDec/index.js');
const FAEquipments = lazyScreen(() => import('../pages/fa/FAEquipments/index.js'), 'pages/fa/FAEquipments/index.js');
const FAEquipment = lazyScreen(() => import('../pages/fa/FAEquipment/index.js'), 'pages/fa/FAEquipment/index.js');
const FAEquipmentDepreciates = lazyScreen(() => import('../pages/fa/FAEquipmentDepreciates/index.js'), 'pages/fa/FAEquipmentDepreciates/index.js');
const FAEquipmentDisposes = lazyScreen(() => import('../pages/fa/FAEquipmentDisposes/index.js'), 'pages/fa/FAEquipmentDisposes/index.js');
const FAEquipmentDispose = lazyScreen(() => import('../pages/fa/FAEquipmentDispose/index.js'), 'pages/fa/FAEquipmentDispose/index.js');
const FAEquipmentRegisters = lazyScreen(() => import('../pages/fa/FAEquipmentRegisters/index.js'), 'pages/fa/FAEquipmentRegisters/index.js');
const FAEquipmentRegister = lazyScreen(() => import('../pages/fa/FAEquipmentRegister/index.js'), 'pages/fa/FAEquipmentRegister/index.js');

export default [
    {
        path: '/fa/FAAsset/:code',
        component: FAAsset
    },
    {
        path: '/fa/FAAssets',
        component: FAAssets
    },
    {
        path: '/fa/FAAssetDepreciates',
        component: FAAssetDepreciates
    },
    {
        path: '/fa/FAAssetDispose/:code',
        component: FAAssetDispose
    },
    {
        path: '/fa/FAAssetDisposes',
        component: FAAssetDisposes
    },
    {
        path: '/fa/FAAssetRegister/:code',
        component: FAAssetRegister
    },
    {
        path: '/fa/FAAssetRegisters',
        component: FAAssetRegisters
    },
    {
        path: '/fa/FAAssetAdjInc/:code',
        component: FAAssetAdjInc
    },
    {
        path: '/fa/FAAssetAdjIncs',
        component: FAAssetAdjIncs
    },
    {
        path: '/fa/FAAssetAdjDec/:code',
        component: FAAssetAdjDec
    },
    {
        path: '/fa/FAAssetAdjDecs',
        component: FAAssetAdjDecs
    },

    {
        path: '/fa/FAEquipment/:code',
        component: FAEquipment
    },
    {
        path: '/fa/FAEquipments',
        component: FAEquipments
    },
    {
        path: '/fa/FAEquipmentDepreciates',
        component: FAEquipmentDepreciates
    },
    {
        path: '/fa/FAEquipmentDispose/:code',
        component: FAEquipmentDispose
    },
    {
        path: '/fa/FAEquipmentDisposes',
        component: FAEquipmentDisposes
    },
    {
        path: '/fa/FAEquipmentRegister/:code',
        component: FAEquipmentRegister
    },
    {
        path: '/fa/FAEquipmentRegisters',
        component: FAEquipmentRegisters
    }
];
